<ng-container *ngIf="viewMode === 'form'">
  <label>{{ dynamicFormField.label }}</label>
  <ellipse-calculator-input (calculatorModalOpen)="onOpenCalculatorModal()"
                            [formControl]="dynamicFormField.formControl"></ellipse-calculator-input>
</ng-container>
<ellipse-dynamic-summary-field *ngIf="viewMode === 'summary'" [label]="dynamicFormField.label" [value]="dynamicFormField.formControl.value['score']"/>
